import type { FC, ReactNode } from 'react';
import React, { memo } from 'react';
import { styled } from '@compiled/react';
import isEqual from 'lodash/isEqual';

import { MenuSection, MenuSectionHeading } from '@atlaskit/side-nav-items/menu-section';

import type { Space } from '@confluence/space-utils/entry-points/useSpacesData.ts';

import { SpacesDropdownItem } from './SpacesDropdownItem.tsx';

type SpacesDropdownSectionProps = {
	listId: string;
	heading?: ReactNode;
	spaces?: Space[];
	currentSpace?: Space;
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const SpaceList = styled.ul({
	listStyleType: 'none',
	width: '100%',
	padding: 0,
	margin: 0,
});

const SECTION_TITLE_ID_PREFIX = 'spaces-dropdown-section-header-';

export const SpacesDropdownSection: FC<SpacesDropdownSectionProps> = memo(
	({ listId, heading, spaces, currentSpace }) => {
		const spaceList = (
			<SpaceList aria-labelledby={`${SECTION_TITLE_ID_PREFIX}${listId}`}>
				{currentSpace && (
					<SpacesDropdownItem
						space={currentSpace}
						key={currentSpace.alias || currentSpace.id!}
						listId={listId}
					/>
				)}
				{spaces &&
					spaces.map((space) => {
						return <SpacesDropdownItem space={space} key={space.id} listId={listId} />;
					})}
			</SpaceList>
		);

		return (
			<MenuSection>
				{heading && <MenuSectionHeading>{heading}</MenuSectionHeading>}
				{spaceList}
			</MenuSection>
		);
	},
	isEqual,
);
